function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.0345 29.9C17.0345 28.4143 18.1194 27.3092 19.5906 27.3001C21.0249 27.291 22.2478 28.4415 22.2754 29.8366C22.303 31.3041 21.0801 32.518 19.5906 32.4998C18.1011 32.4908 17.0345 31.4037 17.0345 29.9Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9735 12.4317C18.4924 13.8275 18.1251 14.8984 17.7577 15.9694C15.2824 23.0798 12.7809 30.1902 10.3406 37.3181C9.91203 38.5822 9.22979 39.0562 7.9003 38.9948C5.73115 38.8982 3.54449 38.9772 1.36659 38.9684C-0.0328653 38.9596 -0.260276 38.6348 0.247027 37.3181C4.183 27.0651 8.13645 16.8121 12.0724 6.55909C12.7109 4.89122 13.3669 3.23213 13.9617 1.55548C14.3465 0.475754 15.0025 -0.0333852 16.1746 0.0017278C18.0376 0.0631756 19.9006 0.0631756 21.7549 0.0017278C22.892 -0.0333852 23.5042 0.466976 23.8978 1.47648C25.7521 6.28696 27.6414 11.0887 29.5044 15.8904C32.2246 22.913 34.9273 29.9444 37.6475 36.9758C38.3122 38.7051 38.1373 38.9684 36.248 38.9684C34.0264 38.9684 31.8135 38.9333 29.6006 38.986C28.621 39.0035 28.07 38.6349 27.7463 37.7044C25.5947 31.5245 23.408 25.3621 21.2476 19.191C20.5042 17.0667 19.8044 14.9248 18.9735 12.4317Z",
  fill: "#17E5D6"
});

var SvgVivadata = function SvgVivadata(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVivadata, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vivadata.6e23b6c4.svg";
export { ForwardRef as ReactComponent };